module.exports = __webpack_public_path__ + "static/media/UniNeueLight-Italic.838d68eb.woff2";